export default __webpack_public_path__ + "static/media/In-White-72.36e6f711.webp";